import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../';
import { dateTimeFormat, generateReportName } from 'GenericForms/Helper';
import Loading from './Loading';

const ReportDetailsHeader = () => {
    /** State variables */
    const { CurrentReport } = useSelector((state: RootState) => state.Reporting);
    const currentVesselReport = CurrentReport?.data?.vessel_reporting_information ?? null;
    /** State variables end */

    if (!currentVesselReport) return <Loading message="Loading required data!" />;
    return (
        <div className='mb-2' key={currentVesselReport}>
            <h5 className="pos-end">{generateReportName(currentVesselReport)} Report</h5><br />
            <p className="text-muted mb-0 font-size-12 pos-end">
                {dateTimeFormat(currentVesselReport.local_time, false, false, true)}
            </p>
        </div>
    )
}

export default ReportDetailsHeader